import { render, staticRenderFns } from "./Register-entrada.vue?vue&type=template&id=32efe35e&"
import script from "./Register-entrada.vue?vue&type=script&lang=js&"
export * from "./Register-entrada.vue?vue&type=script&lang=js&"
import style0 from "./Register-entrada.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports